// This is a refactored version of the Time.js screen using custom styled button tabs
// with a visual style inspired by the NotificationBell component tabs

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { LuCalendarDays, LuTimer } from "react-icons/lu";
import RestaurantCalendarOpenClosedDays from "../components/restaurant_schedule/RestaurantCalendarOpenClosedDays";
import EstimatedTimePage from "../components/EstimatedTimeCustomersSpend";
import DropDownButton from "../components/DropDownButton";
import { fetchRestaurantDetails, fetchRestaurantOpenDays, updateRestaurant, fetchHoursEach, fetchPlaceOfTable } from "../actions/restaurantActions";
import { Container, CardHeader, CardHeaderTitle, FormGroup, InsideFormGroup, Input, InlineText, ModernButton } from "../components/DefaultImports";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCalendar, faStopwatch, faGear } from "@fortawesome/free-solid-svg-icons";
function Time() {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const params = useParams();
  const [restaurant_id, setRestaurant_id] = useState(false);
  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [errorMessage, setErrorMessage] = useState("ok_status");
  const [showError, setShowError] = useState(false);
  const [activeTab, setActiveTab] = useState("calendar");
  const restaurantDetails = useSelector(state => state.restaurantDetails);
  const {
    restaurants
  } = restaurantDetails;
  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
      dispatch(fetchPlaceOfTable(restaurants.id));
    }
  }, [restaurants]);
  useEffect(() => {
    dispatch(fetchRestaurantOpenDays(restaurant_id));
    dispatch(fetchHoursEach(restaurant_id));
  }, [dispatch, restaurant_id]);
  useEffect(() => {
    if (restaurants) {
      if (restaurants.each_time) setEachTime(restaurants.each_time);
      if (restaurants.accept_people_per_each_time !== undefined) setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      if (restaurants.limit_people_reservation !== undefined) setLimitPeopleReservation(restaurants.limit_people_reservation);
    }
  }, [restaurants]);
  const handleIntervalTimeChange = option => setEachTime(option);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    if (name === "accept_people_per_each_time") {
      setAcceptPeoplePerEachTime(value);
    } else if (name === "limit_people_reservation") {
      setLimitPeopleReservation(value);
    }
  };
  function checkEmptyStates() {
    let emptyStates = [];
    if (!eachTime) emptyStates.push(t("ui.i18nFinalCleanup.timeInterval"));
    if (!acceptPeoplePerEachTime || acceptPeoplePerEachTime <= 0) emptyStates.push(t("ui.i18nFinalCleanup.capacityPerSlot"));
    if (!limitPeopleReservation || limitPeopleReservation <= 0) emptyStates.push(t("ui.i18nFinalCleanup.groupLimit"));
    return emptyStates.length > 0 ? t("ui.i18nFinalCleanup.fillFields", { fields: emptyStates.join(", ") }) : "ok_status";
  }
  function checkForErrorsAndUpdateRestaurant() {
    const status_error = checkEmptyStates();
    setErrorMessage(status_error);
    if (status_error === "ok_status") {
      setShowError(false);
      dispatch(updateRestaurant(restaurant_id, {
        each_time: eachTime,
        accept_people_per_each_time: acceptPeoplePerEachTime,
        limit_people_reservation: limitPeopleReservation
      }));
      toast.success(t("ui.i18nMessages.savedSuccessfully"), {
        style: {
          color: "#EE754C"
        },
        icon: <FontAwesomeIcon icon={faCheckCircle} style={{
          color: "#EE754C"
        }} />,
        progressStyle: {
          backgroundColor: "#EE754C"
        },
        autoClose: 1000
      });
    } else {
      setShowError(true);
    }
  }
  const handleSubmit = e => {
    e.preventDefault();
    checkForErrorsAndUpdateRestaurant();
  };
  return <HoursPage>
      <ToastContainer />
      <HoursHeader>
        <HoursTitle>{t("ui.screens.time.horarios")}</HoursTitle>
      <TabsContainer data-setup-tour="hours">
        <StyledTabButton type="button" $active={activeTab === "calendar"} aria-pressed={activeTab === "calendar"} onClick={() => setActiveTab("calendar")}>
          <LuCalendarDays />{t("ui.screens.time.horario")}</StyledTabButton>
        <StyledTabButton type="button" $active={activeTab === "estimated"} aria-pressed={activeTab === "estimated"} onClick={() => setActiveTab("estimated")}>
          <LuTimer />{t("ui.screens.time.duracoesMedias")}</StyledTabButton>
        {/*         <StyledTabButton
          active={activeTab === "settings"}
          onClick={() => setActiveTab("settings")}
         >
          <FontAwesomeIcon icon={faGear} /> Definições
         </StyledTabButton> */}
      </TabsContainer>
      </HoursHeader>

      {activeTab === "calendar" && <RestaurantCalendarOpenClosedDays restaurant_id={restaurant_id} />}
      {activeTab === "estimated" && <EstimatedTimePage restaurant_ids={restaurant_id} />}

      {activeTab === "settings" && <div style={{
      width: "100%",
      display: "flex",
      textAlign: "start",
      justifyContent: "start"
    }}>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <InsideFormGroup>
                <InlineText>{t("ui.screens.time.permitirNoTotal")}</InlineText>
                <Input type="number" id="accept_people_per_each_time" name="accept_people_per_each_time" value={acceptPeoplePerEachTime} onChange={handleChange} />
                <InlineText>{t("ui.screens.time.pessoasACada")}</InlineText>
                <DropDownButton options={["00:15", "00:30", "00:45"]} handleOptionChange={handleIntervalTimeChange} initialOption={eachTime} />
                <InlineText>{t("ui.screens.time.minutos")}</InlineText>
              </InsideFormGroup>
            </FormGroup>

            <FormGroup>
              <InlineText>{t("ui.screens.time.numeroMaximoDePessoasPorGrupo")}</InlineText>
              <Input type="number" id="limit_people_reservation" name="limit_people_reservation" value={limitPeopleReservation} onChange={handleChange} />
            </FormGroup>

            {errorMessage !== "ok_status" && <div style={{
          color: "red",
          marginBottom: "10px"
        }}>
                {errorMessage}
              </div>}

            <ModernButton type="submit" color="#ff704d">{t("ui.screens.time.gravar")}</ModernButton>
          </Form>
        </div>}
    </HoursPage>;
}
export default Time;
const Form = styled.form`
  max-width: 600px;
  width: 100%;
`;
const HoursPage = styled(Container)`
  min-width: 0;
  background: #fff;
  color: #344b46;
`;
const HoursHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  padding-bottom: 16px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e7ece9;
`;
const HoursTitle = styled.h1`
  margin: 0;
  color: #ee754c;
  font-size: 22px;
  line-height: 1.4;
  font-weight: 750;
`;
const TabsContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 3px;
  margin: 0;
  background: #f4f7f5;
  border: 0;
  border-radius: 9px;

  @media (max-width: 768px) {
    display: flex;
    max-width: 100%;
  }
`;
const StyledTabButton = styled.button`
  min-height: 34px;
  padding: 7px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 8px;
  background: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
  color: ${({ $active }) => ($active ? "#c65c38" : "#71827a")};
  box-shadow: none;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
  transition: all 0.18s ease;
  svg { width: 16px; height: 16px; flex-shrink: 0; stroke-width: 1.75; }
  &:focus-visible { outline: 2px solid #ee754c; outline-offset: 2px; }

  &:hover {
    color: #ee754c;
    background: #ffffff;
  }

  @media (max-width: 768px) {
    flex: 1 1 0;
  }
`;
